<template>
  <div class="content">
    <div class="row">
      <div class="col-md-4">
      </div>
      <div class="col-md-4">
        <form>
          <div class="row" style="margin-top: 100px">
            <div class="col-md-12" style="text-align: left">
              <base-input :label="'Логин'"
                          v-model="login"
                          :placeholder="'введите логин'">
              </base-input>
              <br/>
              <base-input :label="'Пароль'" :type="'password'"
                          v-model="password"
                          :placeholder="'введите пароль'">
              </base-input>
            </div>
          </div>
          <div class="row" style="margin-top: 50px">
            <div class="col-md-12">
              <base-button type="success" @click="logIn">Войти</base-button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-4">
      </div>
    </div>
  </div>
</template>
<script>
import BaseInput from "@/components/Inputs/BaseInput";
import {userService} from "@/services/user.service";

export default{
  components:{
    BaseInput
  },
  data() {
    return {
      login: "",
      password: ""
    }
  },
  methods: {
    logIn() {
      userService.login(this.login, this.password);
    }
  }
}
</script>
